// @flow
import { priceTypes, type PriceTypes } from 'app/common/api/general.types/tariff.pricediscounted';
import PriceDiscounted from './PriceDiscounted';
import PriceDiscountedConstruct from './PriceDiscountedConstruct';
import usePriceDiscounted from './usePriceDiscounted';

export default PriceDiscounted;
export { priceTypes, PriceDiscountedConstruct, usePriceDiscounted };
export type { PriceTypes };
